import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router';
import { initAnalytics } from './lib/analytics';
import './styles/haplika.css';
import './styles/app.css';
import AuthPage, { CompanyAccountBoundary } from './auth/Account';

const Landing = lazy(() => import('./landing/Landing'));
const EmpresasApp = lazy(() => import('./empresas/EmpresasApp'));
const CandidatosApp = lazy(() => import('./candidatos/CandidatosApp'));
const Backoffice = lazy(() => import('./backoffice/Backoffice'));

if (!window.location.pathname.startsWith('/auth/')) initAnalytics();

function CandidateLink() {
  const location = useLocation();
  return <Navigate to={`/app${location.pathname}${location.search}${location.hash}`} replace />;
}

function AuthRoute() {
  const location = useLocation();
  return <AuthPage key={`${location.pathname}${location.hash}`} />;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Landing aud="empresas" />} />
          <Route path="/empresas" element={<Landing aud="empresas" />} />
          <Route path="/candidatos" element={<Landing aud="candidatos" />} />
          <Route path="/empresas/*" element={<CompanyAccountBoundary><EmpresasApp /></CompanyAccountBoundary>} />
          <Route path="/auth/*" element={<AuthRoute />} />
          <Route path="/app/*" element={<CandidatosApp />} />
          {/* Universal links viejos de la app: en la web, Procesos o el proceso de ese chat. */}
          <Route path="/mensajes" element={<CandidateLink />} />
          <Route path="/chat/:id" element={<CandidateLink />} />
          <Route path="/reservar/*" element={<CandidateLink />} />
          <Route path="/admin/*" element={<Backoffice />} />
          <Route path="*" element={<Landing aud="empresas" />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </StrictMode>,
);
